import { matchPath } from 'react-router-dom'

const PATIENT_PARAM_SUFFIX = /\/:(?:hn|an|vn)$/

export const getDebugVisibilityFormKey = (pathname, routes = []) => {
  const routeMatch = routes.map(({ path, exact }) =>
    matchPath(pathname, { path, exact }),
  ).find(Boolean)
  let routePath = routeMatch?.path || ''
  let pagePath = pathname.replace(/\/$/, '') || '/'

  while (PATIENT_PARAM_SUFFIX.test(routePath)) {
    routePath = routePath.replace(PATIENT_PARAM_SUFFIX, '')
    pagePath = pagePath.slice(0, pagePath.lastIndexOf('/')) || '/'
  }

  return `auto-field-visibility:${pagePath}`
}
